
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"text-indent":"0","text-align":"start","line-height":"normal","text-transform":"none","block-progression":"tb","-inkscape-font-specification":"Bitstream Vera Sans"},attrs:{"d":"M2 7v7h1c1.19 0 2 .81 2 2s-.81 2-2 2H2v7h14.063c.498 3.933 3.872 7 7.937 7 4.406 0 8-3.594 8-8 0-3.295-2.019-6.152-4.875-7.375A1.585 1.585 0 0127 16c0-1.19.81-2 2-2h1V7H2zm2 2h24v3.188c-1.715.45-3 1.955-3 3.812v.063A7.882 7.882 0 0024 16c-4.065 0-7.439 3.067-7.938 7H4v-3.188c1.715-.45 3-1.955 3-3.812 0-1.857-1.285-3.362-3-3.813V9zm20 9c3.326 0 6 2.674 6 6s-2.674 6-6 6-6-2.674-6-6 2.674-6 6-6zm-1 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z","overflow":"visible","font-family":"Bitstream Vera Sans"}})])
          )
        }
      }
    